import { GoSearch } from "react-icons/go";

export const menu = [{ name: "All", icon: <GoSearch /> }];

export const quickLinks = [
  "About",
  "Advertising",
  "Business",
  "How Search works",
];
export const settingMenu = ["Privacy", "Terms", "Settings"];

export const pagination = [
  { page: 1, startIndex: 1 },
  { page: 2, startIndex: 11 },
  { page: 3, startIndex: 21 },
  { page: 4, startIndex: 31 },
  { page: 5, startIndex: 41 },
  { page: 6, startIndex: 51 },
  { page: 7, startIndex: 61 },
  { page: 8, startIndex: 71 },
  { page: 9, startIndex: 81 },
  { page: 10, startIndex: 91 },
];
